(function () {
  function initCtrIngredients(container) {
    var swiperEl = container.querySelector('.ctr-ingredients__slider');
    var scrollbarEl = container.querySelector('.ctr-ingredients__progress');

    if (!swiperEl) return;

    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      grabCursor: true,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
      },
      mousewheel: true,
      breakpoints: {
        768: {
          spaceBetween: 32,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
      },
    });
  }

  function init() {
    document.querySelectorAll('[data-ctr-ingredients]').forEach(initCtrIngredients);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-ctr-ingredients]');
    if (section) initCtrIngredients(section);
  });
})();
